import type { IJobAssociatedMaintenanceIssue } from '@/interfaces'

class JobAssociatedMaintenanceIssue implements IJobAssociatedMaintenanceIssue {
  issueId: string

  issue: any

  constructor(maintenanceIssue?: any) {
    this.issueId = maintenanceIssue.issueId
    this.issue = maintenanceIssue.issue
  }
}

export default JobAssociatedMaintenanceIssue
